import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackContextMenuClick } from './tracking';
import { ChatListContextMenu, TMenuItem } from '../../components/ChatList/ChatListContextMenu';
import { useOfferByChatId, useOpponentByChatId } from '../../hooks';
import { useChatListContextMenuActions } from '../../hooks/useChatListContextMenuActions';
import { chatListSelector } from '../../selectors';
import { EDeviceType } from '../../types/deviceType';

type TChatListContextMenuContainerProps = {
  listRef: React.RefObject<HTMLDivElement>;
};

export const ChatListContextMenuContainer: React.FC<TChatListContextMenuContainerProps> = ({ listRef }) => {
  const [menuItems, setMenuItems] = React.useState<TMenuItem[]>([]);

  const getMenuItems = useChatListContextMenuActions();
  const { isChangeListActive, chats } = useSelector(chatListSelector);

  const device = useDeviceType();
  const isMobile = device !== EDeviceType.Desktop;

  const getOfferByChatId = useOfferByChatId();
  const getOpponentByChatId = useOpponentByChatId();

  const onShowContextMenu = React.useCallback(
    (selectedChatId: string) => {
      const offer = getOfferByChatId(selectedChatId);
      const opponentId = getOpponentByChatId(selectedChatId);

      const chat = chats.find(chat => chat.chatId === selectedChatId);

      setMenuItems(
        getMenuItems({
          unreadCount: chat?.unread || 0,
          isStarred: chat?.isStarred || false,
          availableActions: chat?.availableActions || undefined,
        }),
      );

      trackContextMenuClick(offer, opponentId);
    },
    [chats, getMenuItems, getOfferByChatId, getOpponentByChatId],
  );

  if (isMobile || isChangeListActive) {
    return null;
  }

  return <ChatListContextMenu listRef={listRef} menuItems={menuItems} onShowContextMenu={onShowContextMenu} />;
};
